"use client";

import { useEffect } from "react";

type Props = {
  slug: string;
};

/**
 * マウント時に1回だけ /api/view へ POST し、記事の閲覧数を加算する。
 * 同一セッションで同一 slug の二重カウントを防ぐため sessionStorage を使う。
 * 表示は持たない（return null）。
 */
export default function ViewTracker({ slug }: Props) {
  useEffect(() => {
    if (!slug) return;
    const key = `viewed:${slug}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, "1");
    } catch {
      // sessionStorage 不可（プライベートモード等）でも計測は試みる
    }

    void fetch("/api/view", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ slug }),
      keepalive: true,
    }).catch(() => {
      // 計測失敗は無視
    });
  }, [slug]);

  return null;
}
